import { motion } from 'framer-motion';
import styled from 'styled-components';

interface ICardProps extends React.HTMLAttributes<HTMLDivElement> {
  key?: string;
  backgroundColor?: string;
  fluid?: boolean;
  flexDirection?: string;
  limited?: boolean;
}

export const Card = styled(motion.div)<ICardProps>`
  display: flex;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : '#fdfdfd'};
  border-radius: 8px;
  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15),
    1px 1px 3px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15),
    1px 1px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15), 1px 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  margin-bottom: 10px;
  width: ${props => (props.fluid ? 'calc(100% - 30px);' : undefined)};
  padding: 15px;
  ${props => (props.limited ? 'max-width: 1000px;' : null)}
  flex-direction: ${props =>
    props.flexDirection ? props.flexDirection : 'column'};
`;
